import React from 'react'

import Content from 'components/base/Content'
import { SectionRuleContent } from 'components/base/SectionRule/styles'
import AskQuestion from 'components/blocks/AskQuestion'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'
import FlexContent from 'components/base/FlexContent'
import Img from 'components/base/Img'
import ResponsiveImage from 'components/base/ResponsiveImage'

import UnitedLogo from 'assets/images/logo-united-healthcare.svg'
import InlLogo from 'assets/images/inl-logo.svg'


interface EventDetailsFooterProps {
  disclaimer?: string,
}

const EventDetailsFooter: React.FC<EventDetailsFooterProps> = ({ disclaimer }) => {
  return (
    <>
      <Content large={true}>
        <SectionRuleContent />
      </Content>
      <AskQuestion title='We’re Here, When You Need Us'>
        Reach out and an Insurance Concierge<sup>®</sup> will get in touch!
      </AskQuestion>
      <Content large={true}>
        <SectionRuleContent />
      </Content>
      <Content large={true} margined={true}>
        <FlexContent
          flexDirection='row'
          gap='60px'
          margined={true}
        >
          <ResponsiveImage width320={true}>
            <Img src={UnitedLogo} src2x={undefined} alt='Expand' />
          </ResponsiveImage>
          <ResponsiveImage width320={true}>
            <Img src={InlLogo} src2x={undefined} alt='Expand' />
          </ResponsiveImage>
        </FlexContent>
        <Paragraph theme={ParagraphTheme.small} alignCenter={true}>
          {disclaimer}
        </Paragraph>
      </Content>
    </>
  )
}

export default EventDetailsFooter
